"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.b2bContactUs = void 0;
const helpers_1 = require("../../helpers");
const sendEmail_1 = require("../sendEmail");
const b2bContactUs = async (firstName, lastName, email, phoneNumber, companyName, companyWebsite, companyCountry, yourMessage) => {
    const email_obj = {
        language_code: "en",
        data: {
            agent: {
                logo: "https://golfsavers.b-cdn.net/assets/images/golfb2b_email_logo.jpg",
            },
            firstName,
            lastName,
            email,
            phoneNumber,
            companyName,
            companyWebsite,
            companyCountry,
            yourMessage,
        },
        template_id: helpers_1.GOLFB2B_CONTACT_US_NOTIFICATION,
    };
    await (0, sendEmail_1.sendEmail)(email_obj);
    return null;
};
exports.b2bContactUs = b2bContactUs;
